import { GraduationCap, Users, TrendingUp, Shield, Clock, BarChart3 } from 'lucide-react';

const features = [
  {
    icon: GraduationCap,
    title: 'Expert Mentorship',
    description: 'Learn from experienced traders with proven track records in the Indian stock market.',
  },
  {
    icon: Users,
    title: 'Active Community',
    description: 'Join a supportive community of 500+ traders sharing insights and strategies daily.',
  },
  {
    icon: TrendingUp,
    title: 'Practical Training',
    description: 'Real-world examples and live market analysis to help you apply what you learn.',
  },
  {
    icon: Shield,
    title: 'Risk Management',
    description: 'Master the art of protecting your capital with proven risk management techniques.',
  },
  {
    icon: Clock,
    title: 'Flexible Learning',
    description: 'Learn at your own pace with 24/7 access to all course materials and recordings.',
  },
  {
    icon: BarChart3,
    title: 'Portfolio Intelligence',
    description: 'Advanced capital allocation strategies and personalized portfolio performance monitoring.',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="section-padding bg-background relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-primary/3 blur-[100px] pointer-events-none" />

      <div className="container-max relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="inline-block px-4 py-2 bg-primary/5 border border-primary/10 rounded-full text-primary text-[10px] font-black uppercase tracking-[0.2em] mb-6">
            Our Advantage
          </span>
          <h2 className="heading-lg text-primary mb-6">
            Your Path to <span className="text-gradient-gold">Trading Sovereignty</span>
          </h2>
          <p className="text-lg text-muted-foreground font-medium">
            We don't just teach trading; we build professional investors through a structured, multi-dimensional learning framework.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="card-premium group relative bg-white/40 overflow-hidden border-white/60"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative z-10">
                <div className="w-16 h-16 rounded-2xl bg-white shadow-soft flex items-center justify-center mb-8 group-hover:bg-accent group-hover:scale-110 transition-all duration-500 border border-gray-100">
                  <feature.icon className="w-8 h-8 text-primary group-hover:text-accent-foreground transition-colors duration-500" />
                </div>
                <h3 className="text-xl font-black text-primary mb-4 uppercase tracking-tighter">{feature.title}</h3>
                <p className="text-muted-foreground text-sm font-medium leading-relaxed">{feature.description}</p>
              </div>

              {/* Subtle background icon for "luxury" feel */}
              <div className="absolute -bottom-6 -right-6 opacity-[0.03] group-hover:opacity-[0.07] transition-opacity duration-500 rotate-12">
                <feature.icon className="w-32 h-32 text-primary" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
